import { useRef, useEffect, useState } from "react";
import axios from "axios";
import io from "socket.io-client";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../NavBars/ActionToolbar";
import SherComboBox from "../../ComboBoxes/SherComboBox";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import { useLocation } from "react-router-dom";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";

import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

const defaultSchemeRedeemFormFields = [
  // Left card (top -> bottom)
  { fieldId: "EntryNo",      fieldName: "Entry No",       tabIndex: 0,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Number",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "SchemeName",   fieldName: "Scheme Name",    tabIndex: 1,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Select",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "AccountNumber",fieldName: "Account Number", tabIndex: 2,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Select",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "CustomerName", fieldName: "Customer Name",  tabIndex: 3,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Select",   fontSize: 11, fontStyle: "Normal" },
  // Right card (top -> bottom)
  { fieldId: "Date",         fieldName: "Date",           tabIndex: 4,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Date",     fontSize: 11, fontStyle: "Normal" },
  { fieldId: "Agent",        fieldName: "Agent",          tabIndex: 5,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Select",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "Amount",       fieldName: "Amount",         tabIndex: 6,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Number",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "GoldRate",     fieldName: "Gold Rate",      tabIndex: 7,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Number",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "RedeemedGrams",fieldName: "Redeemed Grams", tabIndex: 8,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Number",   fontSize: 11, fontStyle: "Normal" },
  { fieldId: "PrintGrams",   fieldName: "Print Grams",    tabIndex: 9,  defaultValue: "", visible: true, enabled: true, checked: false, type: "Checkbox", fontSize: 11, fontStyle: "Normal" },
  // Bottom
  { fieldId: "Narration",    fieldName: "Narration",      tabIndex: 10, defaultValue: "", visible: true, enabled: true, checked: false, type: "Text",     fontSize: 11, fontStyle: "Normal" },
  { fieldId: "Active",       fieldName: "Active",         tabIndex: 11, defaultValue: "", visible: true, enabled: true, checked: false, type: "Checkbox", fontSize: 11, fontStyle: "Normal" },
  // Toolbar buttons
  { fieldId: "SaveBtn",   fieldName: "Save",     tabIndex: 12, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "PrintBtn",  fieldName: "Print",    tabIndex: 13, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "ClearBtn",  fieldName: "Clear",    tabIndex: 14, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "FindBtn",   fieldName: "Find",     tabIndex: 15, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "EditBtn",   fieldName: "Edit",     tabIndex: 16, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "DeleteBtn", fieldName: "Delete",   tabIndex: 17, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "ExitBtn",   fieldName: "Exit",     tabIndex: 18, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "FirstBtn",  fieldName: "First",    tabIndex: 19, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "PrevBtn",   fieldName: "Previous", tabIndex: 20, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "NextBtn",   fieldName: "Next",     tabIndex: 21, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" },
  { fieldId: "LastBtn",   fieldName: "Last",     tabIndex: 22, defaultValue: "", visible: true, enabled: true, checked: false, type: "Button", fontSize: 11, fontStyle: "Normal" }
];

function SchemeRedeem(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  
  const location = useLocation();
  const routeState = location.state || {};
  const vType = props.voucherType || routeState.typeOfVoucher || props.formName || routeState.abbreviation || "SCHEME REDEEM";

  return (
    <FormDesignProvider
      formName={vType}
      defaultFields={defaultSchemeRedeemFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <SchemeRedeemInner {...props} />
    </FormDesignProvider>
  );
}

function SchemeRedeemInner({ onClose, zIndex, formId: propFormId, formName: propFormName, voucherType: propVoucherType }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const permissions = useSelector(selectMenuPermissions);
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId"));
  const locationId = activeLocation?.id || Number(sessionStorage.getItem("loginLocationId")) || Number(localStorage.getItem("loginLocationId"));

  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };
  
  const location = useLocation();
  const routeState = location.state || {};
  const formId = propFormId || routeState.fId || 2;
  const formName = propFormName || routeState.abbreviation || "SchRedeem-admin";
  const voucherType = propVoucherType || routeState.typeOfVoucher || "SCHEME REDEEM";

  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY bounds
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  // ==================== STATE MANAGEMENT ====================
  const [agentCode, setAgentCode] = useState("");

  // Form data state
  const [schemeRedeemData, setschemeRedeemData] = useState({
    entryNo: 1,
    date: getCurrentDate(),
    schemeId: "",          // value (ID)
    schemeName: "",        // label
    accountNameId: "",     // value (ID)
    accountName: "",       // label
    agentId: "",           // value (ID)
    agent: "",             // label
    accountNoId: "",       // value (ID)
    accountNo: "",         // label
    narration: "",
    amount: 0,
    rate: "",
    gm: 0.0,
    printgm: 0,
    isActive: true,
  });

  // Master data states
  const [RegcnameData, setRegCnameData] = useState([]);     // Registered customers
  const [agentName, setagentName] = useState([]);          // Agent names
  const [Accno, setAccno] = useState([]);                 // All account numbers
  const [schemeNames, setschemeNames] = useState([]);     // All scheme names
  const [filteredaccNo, setfilteredaccNo] = useState([]); // Filtered account numbers by scheme
  const [schemedatas, setschemedatas] = useState([]);     // Complete account data with scheme info
  const schemedatasRef = useRef([]);

  // UI states
  const [dataFound, setDataFound] = useState(false);
  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [schred_entryno, setSchredEntryNo] = useState("");
  const [cBalace, setCBalance] = useState("");

  // Redeemable summary states
  const [redeemableAmount, setRedeemableAmount] = useState(0);
  const [redeemableGrams, setRedeemableGrams] = useState(0);
  const [redeemableSummaryFetched, setRedeemableSummaryFetched] = useState(false);
  const [redeemMode, setRedeemMode] = useState(null); // 'total' | 'custom' | null
  const [lastEditedField, setLastEditedField] = useState('amount'); // 'amount' | 'gm'

  // Popup states
  const [showSchemePopup, setShowSchemePopup] = useState(false);
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [selectedAccountNameId, setSelectedAccountNameId] = useState(null);
  const [selectedAccountNameValue, setSelectedAccountNameValue] = useState("");
  const [showFindDialog, setShowFindDialog] = useState(false);
  const [findEntryNo, setFindEntryNo] = useState("");

  // ==================== REFS FOR FOCUS MANAGEMENT ====================
  const accountNameInputRef = useRef(null);
  const agentNameInputRef = useRef(null);
  const accountnumberInputRef = useRef(null);
  const entryNoInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const amountInputRef = useRef(null);
  const narrationInputRef = useRef(null);
  const rateInputRef = useRef(null);
  const gmInputRef = useRef(null);
  const schemeIdInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);

  // ==================== INITIALIZATION EFFECTS ====================
  useEffect(() => {
    const storedAgentCode = sessionStorage.getItem("agentCode");
    if (storedAgentCode) {
      setAgentCode(storedAgentCode);
    }
  }, []);

  useEffect(() => {
    if (agentCode) {
      fetchSchredEntryno();
    }
  }, [agentCode]);

  useEffect(() => {
    triggerInitialFocus();
  }, [triggerInitialFocus]);

  // Apply default values from Form Designer fields configuration
  useEffect(() => {
    if (!formDesignerLoading && formFields && formFields.length > 0 && !dataFound) {
      setschemeRedeemData((prev) => {
        const updated = { ...prev };
        let changed = false;
        
        formFields.forEach((field) => {
          const mapKey = {
            Narration: "narration",
            Amount: "amount",
            GoldRate: "rate",
            PrintGrams: "printgm",
            Active: "isActive"
          }[field.fieldId];
          
          if (mapKey) {
            let val = undefined;
            
            // Check checkbox properties first (checked column in designer)
            if (mapKey === "printgm") {
              if (field.checked !== undefined) {
                val = field.checked ? 1 : 0;
              } else if (field.defaultValue !== undefined && field.defaultValue !== null && field.defaultValue !== "") {
                val = (field.defaultValue === "true" || field.defaultValue === "1" || field.defaultValue === 1 || field.defaultValue === "checked") ? 1 : 0;
              }
            } else if (mapKey === "isActive") {
              if (field.checked !== undefined) {
                val = !!field.checked;
              } else if (field.defaultValue !== undefined && field.defaultValue !== null && field.defaultValue !== "") {
                val = (field.defaultValue === "true" || field.defaultValue === "1" || field.defaultValue === 1 || field.defaultValue === "checked");
              }
            } else {
              // Regular text/number fields
              if (field.defaultValue !== undefined && field.defaultValue !== null && field.defaultValue !== "") {
                if (mapKey === "amount" || mapKey === "rate") {
                  val = parseFloat(field.defaultValue) || field.defaultValue;
                } else {
                  val = field.defaultValue;
                }
              }
            }
            
            if (val !== undefined && prev[mapKey] !== val) {
              updated[mapKey] = val;
              changed = true;
            }
          }
        });
        
        return changed ? updated : prev;
      });
    }
  }, [formFields, formDesignerLoading, dataFound]);

  // ==================== MASTER DATA FETCHING ====================
  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/getSchemes/${dbCode}`
        );

        if (response.data.success) {
          const formattedSchemes = response.data.data.map((item) => ({
            value: item.SchemeId,
            label: item.SchemeName
          }));
          setschemeNames(formattedSchemes);
        }
      } catch (error) {
        console.error("Error fetching schemes:", error);
      }
    };
    if (dbCode) fetchSchemes();

    // WebSocket listener for real-time scheme updates
    const socket = io(apiBaseUrl);
    socket.on("SchemeUpdated", () => {
      if (dbCode) fetchSchemes();
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const fetchRegCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`
        );
        const transformedData = response.data.map((item) => ({
          value: item.accname,
          label: item.LedName,
        }));
        
        // Filter unique customers by their value (accname)
        const uniqueData = [];
        const seen = new Set();
        for (const item of transformedData) {
          if (!seen.has(item.value)) {
            seen.add(item.value);
            uniqueData.push(item);
          }
        }
        
        setRegCnameData(uniqueData);
      } catch (error) {
        console.error("Error fetching regcustomers Values:", error.message);
      }
    };
    if (dbCode) fetchRegCname();
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`
        );
        const transformedData = response.data.map((item) => ({
          value: item.Auto,
          label: item.Name
        }));
        setagentName(transformedData);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };
    if (dbCode) fetchAgname();
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const fetchAcno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_schemeregisteredaccno/${dbCode}`
        );
        const seenAcc = new Set();
        const transformedData = [];
        (response.data || []).forEach((item) => {
          const numStr = String(item.accno ?? "").trim();
          if (numStr && !seenAcc.has(numStr)) {
            seenAcc.add(numStr);
            transformedData.push({
              value: numStr,
              label: numStr,
              auto: item.auto
            });
          }
        });
        schemedatasRef.current = response.data || [];
        setAccno(transformedData);
        setschemedatas(response.data);
        setfilteredaccNo(transformedData);
      } catch (error) {
        console.error("Error fetching account numbers:", error.message);
      }
    };
    if (dbCode) fetchAcno();
  }, [apiBaseUrl, dbCode]);

  // ==================== UTILITY FUNCTIONS ====================
  const handleKeyDown = (event, nextInputRefOrFieldId) => {
    if (event.key === "Enter" || event.key === "Return" || event.key === "Tab") {
      if (nextInputRefOrFieldId === "RedeemedGrams" || nextInputRefOrFieldId === "Amount") {
        if (redeemableSummaryFetched) {
          const enteredGm = parseFloat(schemeRedeemData.gm) || 0;
          const maxGms = parseFloat(redeemableGrams) || 0;
          if (enteredGm > maxGms + 0.0005) {
            alert(`Entered weight (${enteredGm.toFixed(3)} gm) exceeds redeemable weight (${maxGms.toFixed(3)} gm)! Not allowed.`);
            event.preventDefault();
            return;
          }
        }
      }
      event.preventDefault();
      if (typeof nextInputRefOrFieldId === "string") {
        handleDynamicKeyDown(event, nextInputRefOrFieldId);
      } else if (nextInputRefOrFieldId && nextInputRefOrFieldId.current) {
        nextInputRefOrFieldId.current?.focus();
      }
    }
  };

  // ==================== SCHEME & ACCOUNT FILTERING ====================
  const filterAccountNumbersByScheme = (schemeId) => {
    if (!schemeId) {
      setfilteredaccNo(Accno);
      return;
    }

    const activeList = (schemedatas && schemedatas.length > 0) ? schemedatas : (schemedatasRef.current || []);
    const filteredData = activeList.filter(
      (item) => String(item.schemeId ?? item.SchemeId ?? "").trim() === String(schemeId).trim()
    );

    const seenAcc = new Set();
    const transformedData = [];
    filteredData.forEach((item) => {
      const numStr = String(item.accno ?? item.Accno ?? "").trim();
      if (numStr && !seenAcc.has(numStr)) {
        seenAcc.add(numStr);
        transformedData.push({
          value: numStr,
          label: numStr,
          auto: item.auto ?? item.Auto
        });
      }
    });
    setfilteredaccNo(transformedData);
  };

  // ==================== ACCOUNT NAME SELECTION HANDLER ====================
  const handleAccountNameSelection = async (option) => {
    if (!option || !option.value) {
      setschemeRedeemData(prev => ({
        ...prev,
        accountNameId: "",
        accountName: "",
      }));
      return;
    }
    if (schemeRedeemData.accountNameId === option.value) return;

    const accountNameId = option.value;
    const accountNameValue = option.label;

    const accountsWithSameName = schemedatas.filter(
      item => item.accname === parseInt(accountNameId)
    );

    if (accountsWithSameName.length === 0) {
      alert("No account numbers found for this customer");
      return;
    }

    if (accountsWithSameName.length === 1) {
      const accountData = accountsWithSameName[0];
      const accountNoObj = Accno.find(item => item.auto === accountData.auto || item.label === accountData.accno);
      const schemeObj = schemeNames.find(item => item.value === accountData.schemeId);
      const agentObj = accountData.agent ?
        agentName.find(item => item.value === accountData.agent) :
        agentName.find((item) => item.value === parseInt(agentCode));

      const newSchemeId = schemeObj ? schemeObj.value : "";
      const newAccountNoId = accountData?.auto ?? (accountNoObj ? accountNoObj.auto : "");
      const newAccountNoLabel = accountData?.accno ? String(accountData.accno) : (accountNoObj ? accountNoObj.label : "");

      setschemeRedeemData(prev => ({
        ...prev,
        schemeId: newSchemeId,
        schemeName: schemeObj ? schemeObj.label : "",
        accountNameId: accountNameId,
        accountName: accountNameValue,
        accountNoId: newAccountNoId,
        accountNo: newAccountNoLabel,
        agentId: agentObj ? agentObj.value : "",
        agent: agentObj ? agentObj.label : "",
      }));

      if (schemeObj) {
        filterAccountNumbersByScheme(schemeObj.value);
      }

      if (newAccountNoId && newSchemeId) {
        CurrentBalancebyAccno(newAccountNoId, newSchemeId);
        fetchRedeemableSummary(newAccountNoId, newSchemeId);
      }
    } else {
      setSelectedAccountNameId(accountNameId);
      setSelectedAccountNameValue(accountNameValue);

      const uniqueSchemeIds = [...new Set(accountsWithSameName.map(item => item.schemeId))];

      const schemeOptions = uniqueSchemeIds
        .map(schemeId => {
          const scheme = schemeNames.find(item => item.value === schemeId);
          if (scheme) {
            return {
              schemeId: schemeId,
              schemeName: scheme.label,
              accountData: accountsWithSameName.filter(item => item.schemeId === schemeId)
            };
          }
          return null;
        })
        .filter(item => item !== null);

      setAvailableSchemes(schemeOptions);
      setShowSchemePopup(true);
    }
  };

  // ==================== ACCOUNT NUMBER SELECTION HANDLER ====================
  const handlefindAccountNo = async (option) => {
    if (!option || (!option.value && !option.label)) {
      setschemeRedeemData(prev => ({
        ...prev,
        accountNoId: "",
        accountNo: "",
      }));
      setCBalance("");
      setRedeemableAmount(0);
      setRedeemableGrams(0);
      setRedeemableSummaryFetched(false);
      setRedeemMode(null);
      return;
    }
    const accLabel = option.label || option.value || "";
    try {
      const accountData = schemedatas.find(item => item.accno === accLabel || item.auto === option.auto);
      const autoId = accountData?.auto ?? option.auto ?? "";

      if (schemeRedeemData.accountNo === accLabel && schemeRedeemData.accountNoId === autoId) return;

      if (accountData) {
        const schemeObj = accountData.schemeId ?
          schemeNames.find(item => item.value === accountData.schemeId) : null;

        const accountNameObj = accountData.accname ?
          RegcnameData.find(item => item.value === accountData.accname) : null;

        const agentObj = accountData.agent ?
          agentName.find(item => item.value === accountData.agent) :
          agentName.find((item) => item.value === parseInt(agentCode));

        const schemeIdToUse = schemeObj ? schemeObj.value : (accountData.schemeId || "");
        const schemeNameToUse = schemeObj ? schemeObj.label : "";

        setschemeRedeemData(prev => ({
          ...prev,
          schemeId: schemeIdToUse,
          schemeName: schemeNameToUse,
          accountNameId: accountNameObj ? accountNameObj.value : "",
          accountName: accountNameObj ? accountNameObj.label : "",
          agentId: agentObj ? agentObj.value : "",
          agent: agentObj ? agentObj.label : "",
          accountNoId: autoId,
          accountNo: accLabel
        }));

        if (schemeIdToUse) {
          filterAccountNumbersByScheme(schemeIdToUse);
          if (autoId) {
            CurrentBalancebyAccno(autoId, schemeIdToUse);
            fetchRedeemableSummary(autoId, schemeIdToUse);
          }
        }
      } else {
        const defaultAgent = agentName.find((item) => item.value === parseInt(agentCode));

        setschemeRedeemData(prev => ({
          ...prev,
          schemeId: "",
          schemeName: "",
          accountNameId: "",
          accountName: "",
          agentId: defaultAgent ? defaultAgent.value : "",
          agent: defaultAgent ? defaultAgent.label : "",
          accountNoId: autoId,
          accountNo: accLabel,
        }));

        if (autoId) {
          CurrentBalancebyAccno(autoId, null);
        }
      }
    } catch (error) {
      console.error("Error finding account data:", error.message);
    }
  };

  // ==================== SCHEME SELECTION POPUP HANDLER ====================
  const handleSchemeSelection = (schemeOption) => {
    const accountData = schemeOption.accountData[0];
    const accountNoObj = Accno.find(item => item.auto === accountData.auto || item.label === accountData.accno);
    const schemeObj = schemeNames.find(item => item.value === schemeOption.schemeId);
    const agentObj = accountData.agent ?
      agentName.find(item => item.value === accountData.agent) :
      agentName.find((item) => item.value === parseInt(agentCode));

    const newSchemeId = schemeObj ? schemeObj.value : "";
    const newAccountNoId = accountData?.auto ?? (accountNoObj ? accountNoObj.auto : "");
    const newAccountNoLabel = accountData?.accno ? String(accountData.accno) : (accountNoObj ? accountNoObj.label : "");

    setschemeRedeemData(prev => ({
      ...prev,
      schemeId: newSchemeId,
      schemeName: schemeObj ? schemeObj.label : "",
      accountNameId: selectedAccountNameId,
      accountName: selectedAccountNameValue,
      accountNoId: newAccountNoId,
      accountNo: newAccountNoLabel,
      agentId: agentObj ? agentObj.value : "",
      agent: agentObj ? agentObj.label : "",
    }));

    if (schemeObj) {
      filterAccountNumbersByScheme(schemeObj.value);
    }

    if (newAccountNoId && newSchemeId) {
      CurrentBalancebyAccno(newAccountNoId, newSchemeId);
      fetchRedeemableSummary(newAccountNoId, newSchemeId);
    }

    setShowSchemePopup(false);
    setAvailableSchemes([]);
    setSelectedAccountNameId(null);
    setSelectedAccountNameValue("");
  };

  const handleClosePopup = () => {
    setShowSchemePopup(false);
    setAvailableSchemes([]);
    setSelectedAccountNameId(null);
    setSelectedAccountNameValue("");
    setschemeRedeemData({
      ...schemeRedeemData,
      accountName: "",
      accountNameId: "",
    });
  };

  // ==================== ENTRY NUMBER MANAGEMENT ====================
  const fetchSchredEntryno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRed_entryno/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );
      const schemeentryNo = response.data.map((item) => item[""]);
      setschemeRedeemData((prevData) => ({
        ...prevData,
        entryNo: schemeentryNo[0],
      }));
      setSchredEntryNo(schemeentryNo[0]);
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };

  useEffect(() => {
    if (dbCode && agentCode) {
      fetchSchredEntryno();
    }
  }, [apiBaseUrl, agentCode, dbCode, formId]);

  // ==================== GOLD RATE MANAGEMENT ====================
  const fetchSchCurrentRate = async (targetDate) => {
    try {
      const dateToUse = targetDate || schemeRedeemData.date;
      const response = await axios.get(
        `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${dateToUse || ""}`
      );
      const currentrate = response.data[0]?.currentRate;
      setschemeRedeemData((prevData) => {
        const rateVal = currentrate || 0;
        let updatedAmount = prevData.amount;
        let updatedGm = prevData.gm;

        if (redeemMode !== 'total' && !dataFound && rateVal > 0) {
          if (lastEditedField === 'gm') {
            const gmVal = parseFloat(prevData.gm);
            if (!isNaN(gmVal) && gmVal > 0) {
              updatedAmount = (gmVal * rateVal).toFixed(2);
            }
          } else {
            const amtVal = parseFloat(prevData.amount);
            if (!isNaN(amtVal) && amtVal > 0) {
              updatedGm = (amtVal / rateVal).toFixed(3);
            }
          }
        }

        return {
          ...prevData,
          rate: rateVal,
          amount: updatedAmount,
          gm: updatedGm,
        };
      });
    } catch (error) {
      console.error("Error fetching rate:", error.message);
    }
  };

  useEffect(() => {
    if (dbCode) {
      fetchSchCurrentRate(schemeRedeemData.date);
    }
  }, [apiBaseUrl, dbCode, schemeRedeemData.date]);

  // ==================== BIDIRECTIONAL AMOUNT / WEIGHT CALCULATION ====================
  const handleAmountChange = (e) => {
    const val = e.target.value;
    setLastEditedField('amount');
    if (redeemMode !== 'custom' && redeemMode !== 'total') {
      setRedeemMode('custom');
    }

    const amt = parseFloat(val);
    const rate = parseFloat(schemeRedeemData.rate);

    let newGm = schemeRedeemData.gm;
    if (val === "") {
      newGm = "";
    } else if (!isNaN(amt) && !isNaN(rate) && rate > 0) {
      newGm = (amt / rate).toFixed(3);
    }

    setschemeRedeemData((prev) => ({
      ...prev,
      amount: val,
      gm: newGm,
    }));
  };

  const handleGmChange = (e) => {
    if (redeemMode === 'total') return;
    const val = e.target.value;
    setLastEditedField('gm');
    if (redeemMode !== 'custom') {
      setRedeemMode('custom');
    }

    const gmVal = parseFloat(val);
    const rate = parseFloat(schemeRedeemData.rate);

    let newAmount = schemeRedeemData.amount;
    if (val === "") {
      newAmount = "";
    } else if (!isNaN(gmVal) && !isNaN(rate) && rate > 0) {
      newAmount = (gmVal * rate).toFixed(2);
    }

    setschemeRedeemData((prev) => ({
      ...prev,
      gm: val,
      amount: newAmount,
    }));
  };

  const handleRateChange = (e) => {
    const val = e.target.value;
    const newRate = parseFloat(val);

    let updatedAmount = schemeRedeemData.amount;
    let updatedGm = schemeRedeemData.gm;

    if (!isNaN(newRate) && newRate > 0) {
      if (lastEditedField === 'gm') {
        const gmVal = parseFloat(schemeRedeemData.gm);
        if (!isNaN(gmVal) && gmVal > 0) {
          updatedAmount = (gmVal * newRate).toFixed(2);
        }
      } else {
        const amtVal = parseFloat(schemeRedeemData.amount);
        if (!isNaN(amtVal) && amtVal > 0) {
          updatedGm = (amtVal / newRate).toFixed(3);
        }
      }
    }

    setschemeRedeemData((prev) => ({
      ...prev,
      rate: val,
      amount: updatedAmount,
      gm: updatedGm,
    }));
  };

  const handleGmBlur = () => {
    if (!redeemableSummaryFetched) return;
    const enteredGm = parseFloat(schemeRedeemData.gm) || 0;
    const maxGms = parseFloat(redeemableGrams) || 0;
    const rate = parseFloat(schemeRedeemData.rate) || 0;

    if (enteredGm > maxGms + 0.0005) {
      alert(`Entered weight (${enteredGm.toFixed(3)} gm) exceeds redeemable weight (${maxGms.toFixed(3)} gm)! Not allowed.`);
      const clampedGm = maxGms;
      const clampedAmt = rate > 0 ? parseFloat((clampedGm * rate).toFixed(2)) : 0;
      setschemeRedeemData((prev) => ({
        ...prev,
        gm: clampedGm.toFixed(3),
        amount: clampedAmt > 0 ? clampedAmt : prev.amount,
      }));
      setTimeout(() => {
        gmInputRef.current?.focus();
      }, 50);
    }
  };

  const handleAmountBlur = () => {
    if (!redeemableSummaryFetched) return;
    const rate = parseFloat(schemeRedeemData.rate) || 0;
    if (rate <= 0) return;
    const enteredAmt = parseFloat(schemeRedeemData.amount) || 0;
    const calcGm = parseFloat((enteredAmt / rate).toFixed(3));
    const maxGms = parseFloat(redeemableGrams) || 0;

    if (calcGm > maxGms + 0.0005) {
      alert(`Entered amount (₹ ${enteredAmt.toFixed(2)}) corresponds to ${calcGm.toFixed(3)} gm, which exceeds redeemable weight (${maxGms.toFixed(3)} gm)! Not allowed.`);
      const clampedGm = maxGms;
      const clampedAmt = parseFloat((clampedGm * rate).toFixed(2));
      setschemeRedeemData((prev) => ({
        ...prev,
        gm: clampedGm.toFixed(3),
        amount: clampedAmt,
      }));
      setTimeout(() => {
        amountInputRef.current?.focus();
      }, 50);
    }
  };

  // ==================== REDEEMABLE SUMMARY ====================
  const fetchRedeemableSummary = async (accountNoId, schemeId) => {
    try {
      const url = `${apiBaseUrl}/main/redeemableSummary/${accountNoId}/${schemeId}/${dbCode}`;
      const response = await axios.get(url);
      if (response.status === 200 && response.data.length > 0) {
        const data = response.data[0];
        setRedeemableAmount(parseFloat(data.redeemableAmount) || 0);
        setRedeemableGrams(parseFloat(data.redeemableGrams) || 0);
      } else {
        setRedeemableAmount(0);
        setRedeemableGrams(0);
      }
      setRedeemableSummaryFetched(true);
    } catch (error) {
      console.error("Error fetching redeemable summary:", error.message);
      setRedeemableAmount(0);
      setRedeemableGrams(0);
      setRedeemableSummaryFetched(true);
    }
  };

  // ==================== REDEEM MODE HANDLERS ====================
  const handleRedeemAll = () => {
    setLastEditedField('amount');
    const rate = parseFloat(schemeRedeemData.rate) || 0;
    const availGms = redeemableGrams || 0;
    const availAmt = redeemableAmount || 0;

    let targetAmt = availAmt;
    if (availAmt <= 0 && availGms > 0 && rate > 0) {
      targetAmt = parseFloat((availGms * rate).toFixed(2));
      setRedeemMode('custom');
    } else {
      setRedeemMode('total');
    }

    setschemeRedeemData(prev => ({
      ...prev,
      amount: targetAmt,
      gm: availGms.toFixed(3),
    }));
  };

  const handleCustomRedeem = () => {
    setRedeemMode('custom');
    setLastEditedField('amount');
    setschemeRedeemData(prev => ({
      ...prev,
      amount: "",
      gm: "",
    }));
    setTimeout(() => {
      amountInputRef.current?.focus();
    }, 50);
  };

  // Auto-fetch redeemable summary whenever account and scheme are both set
  useEffect(() => {
    if (schemeRedeemData.accountNoId && schemeRedeemData.schemeId && dbCode && !dataFound) {
      fetchRedeemableSummary(schemeRedeemData.accountNoId, schemeRedeemData.schemeId);
    } else if (!schemeRedeemData.accountNoId || !schemeRedeemData.schemeId) {
      setRedeemableAmount(0);
      setRedeemableGrams(0);
      setRedeemableSummaryFetched(false);
      setRedeemMode(null);
    }
  }, [schemeRedeemData.accountNoId, schemeRedeemData.schemeId, dbCode, dataFound]);

  // ==================== CURRENT BALANCE FUNCTIONS ====================
  const CurrentBalancebyAccno = async (accountNoId, schemeId) => {
    try {
      const url = `${apiBaseUrl}/main/currentBalanceBYaccno/${accountNoId}/${schemeId}/${dbCode}`;
      const response = await axios.get(url);
      if (response.status === 200 && response.data && response.data[0]) {
        const foundData = response.data[0];
        setCBalance(foundData.balance);
        fetchAccountStatusByAccno(accountNoId);
      }
    } catch (error) {
      console.error("Error fetching current balance:", error.message);
    }
  };

  const fetchAccountStatusByAccno = async (accountNoId) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getAccountStatusByAccno/${accountNoId}/${dbCode}`
      );
      if (response.status === 200 && response.data.length > 0) {
        const statusData = response.data[0];
        setschemeRedeemData(prev => ({
          ...prev,
          isActive: statusData.isActive === 1 || statusData.isActive === true
        }));
      }
    } catch (error) {
      console.error("Error fetching account status:", error.message);
    }
  };

  const toggleAccountStatus = () => {
    if (!saveDisabled || !editDisabled) {
      setschemeRedeemData(prev => ({
        ...prev,
        isActive: !prev.isActive,
        // Set closedDate to today when closing; clear when re-activating
        closedDate: prev.isActive ? new Date().toISOString().split('T')[0] : null,
      }));
    }
  };

  // ==================== FORM ACTIONS ====================
  const handleSubmit = async () => {
    setSaveDisabled(true);

    if (
      !schemeRedeemData.entryNo ||
      !schemeRedeemData.date ||
      !schemeRedeemData.schemeId ||
      !schemeRedeemData.accountNameId ||
      !schemeRedeemData.agentId ||
      !schemeRedeemData.accountNoId ||
      !schemeRedeemData.amount
    ) {
      alert("Enter Data Correctly");
      setSaveDisabled(false);
      return;
    }

    if (schemeRedeemData.date && !isDateInFy(schemeRedeemData.date)) {
      alert("Date incompatible with financial year");
      setSaveDisabled(false);
      return;
    }

    // Validate weight limit (weight should not exceed accumulated grams)
    const enteredAmount = parseFloat(schemeRedeemData.amount) || 0;
    const enteredGm = parseFloat(schemeRedeemData.gm) || 0;
    const maxGms = parseFloat(redeemableGrams) || 0;
    if (redeemableSummaryFetched && enteredGm > maxGms + 0.0005) {
      alert(`Entered weight (${enteredGm.toFixed(3)} gm) exceeds redeemable weight (${maxGms.toFixed(3)} gm)! It is not allowed.`);
      setSaveDisabled(false);
      return;
    }

    // Compute excess amount (market value above available saved accumulated amount)
    const availableSavings = Math.max(0, redeemableAmount);
    const computedExcess = Math.max(0, parseFloat((enteredAmount - availableSavings).toFixed(2)));

    // If there's an excess, show a clear confirmation with breakdown
    let confirmMsg = "Do you want to save this entry?";
    if (computedExcess > 0) {
      confirmMsg =
        `GOLD APPRECIATION REDEEM CONFIRMATION\n\n` +
        `Accumulated Savings (Cr. Customer):  ₹ ${availableSavings.toFixed(2)}\n` +
        `Gold Appreciation Expense (Dr. Shop): ₹ ${computedExcess.toFixed(2)}\n` +
        `─────────────────────────────────────────\n` +
        `Total Cash to Customer:               ₹ ${enteredAmount.toFixed(2)}\n\n` +
        `The excess ₹ ${computedExcess.toFixed(2)} will be booked to\n` +
        `"GOLD APPRECIATION EXPENSE" ledger.\n\nProceed?`;
    }
    if (!window.confirm(confirmMsg)) {
      setSaveDisabled(false);
      return;
    }
    const resolvedLocId = Number(locationId || activeLocation?.id || sessionStorage.getItem("loginLocationId") || 0);
    if (!resolvedLocId) {
      alert("Location not identified. Please verify location.");
      setSaveDisabled(false);
      return;
    }
    const resolvedFyId = Number(fyid || activeFyid || sessionStorage.getItem("selectedFyId") || 0);
    if (!resolvedFyId) {
      alert("Financial Year not identified. Please select Financial Year.");
      setSaveDisabled(false);
      return;
    }
    const resolvedFormId = Number(formId || 0);

    try {
      const payload = {
        ...schemeRedeemData,
        accountNo: schemeRedeemData.accountNoId.toString(),
        agent: schemeRedeemData.agentId,
        accountName: schemeRedeemData.accountNameId,
        schemeId: schemeRedeemData.schemeId,
        isActive: schemeRedeemData.isActive ? 1 : 0,
        closedDate: schemeRedeemData.isActive ? null : new Date().toISOString().split('T')[0],
        formId: resolvedFormId,
        fyid: resolvedFyId,
        Location: resolvedLocId,
        excessAmount: computedExcess,
      };

      const response = await axios.post(
        `${apiBaseUrl}/main/insertRedeem/${parseInt(agentCode)}/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        handleClear();
        alert("Entry Saved");
      }
    } catch (error) {
      console.error("Error submitting data:", error.message);
      setSaveDisabled(false);
    }
  };

  const handleEdit = async () => {
    try {
      const enteredGmEdit = parseFloat(schemeRedeemData.gm) || 0;
      const maxGmsEdit = parseFloat(redeemableGrams) || 0;
      if (redeemableSummaryFetched && enteredGmEdit > maxGmsEdit + 0.0005) {
        alert(`Entered weight (${enteredGmEdit.toFixed(3)} gm) exceeds redeemable weight (${maxGmsEdit.toFixed(3)} gm)! It is not allowed.`);
        return;
      }

      const enteredAmountEdit = parseFloat(schemeRedeemData.amount) || 0;
      const availableSavingsEdit = Math.max(0, redeemableAmount);
      const computedExcessEdit = Math.max(0, parseFloat((enteredAmountEdit - availableSavingsEdit).toFixed(2)));

      let confirmMsgEdit = "Do you want to edit this entry?";
      if (computedExcessEdit > 0) {
        confirmMsgEdit =
          `GOLD APPRECIATION REDEEM (EDIT) CONFIRMATION\n\n` +
          `Accumulated Savings (Cr. Customer):  ₹ ${availableSavingsEdit.toFixed(2)}\n` +
          `Gold Appreciation Expense (Dr. Shop): ₹ ${computedExcessEdit.toFixed(2)}\n` +
          `─────────────────────────────────────────\n` +
          `Total Cash to Customer:               ₹ ${enteredAmountEdit.toFixed(2)}\n\n` +
          `The excess ₹ ${computedExcessEdit.toFixed(2)} will be booked to\n` +
          `"GOLD APPRECIATION EXPENSE" ledger.\n\nProceed?`;
      }

      const resolvedLocIdEdit = Number(locationId || activeLocation?.id || sessionStorage.getItem("loginLocationId") || 0);
      if (!resolvedLocIdEdit) {
        alert("Location not identified. Please verify location.");
        return;
      }
      const resolvedFyIdEdit = Number(fyid || activeFyid || sessionStorage.getItem("selectedFyId") || 0);
      if (!resolvedFyIdEdit) {
        alert("Financial Year not identified. Please select Financial Year.");
        return;
      }
      const resolvedFormIdEdit = Number(formId || 0);

      const payload = {
        ...schemeRedeemData,
        accountNo: schemeRedeemData.accountNoId.toString(),
        agent: schemeRedeemData.agentId,
        accountName: schemeRedeemData.accountNameId,
        schemeId: schemeRedeemData.schemeId,
        isActive: schemeRedeemData.isActive ? 1 : 0,
        closedDate: schemeRedeemData.isActive ? null : new Date().toISOString().split('T')[0],
        formId: resolvedFormIdEdit,
        fyid: resolvedFyIdEdit,
        Location: resolvedLocIdEdit,
        excessAmount: computedExcessEdit,
      };
      if (!window.confirm(confirmMsgEdit)) {
        return;
      }
      const response = await axios.post(
        `${apiBaseUrl}/main/editRedeem/${parseInt(agentCode)}/${dbCode}`,
        payload
      );

      if (response.status === 200) {
        handleClear();
        alert("Entry Edited");
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleClear = () => {
    // Clear all SherComboBoxes
    [
      schemeIdInputRef,
      accountnumberInputRef,
      accountNameInputRef,
      agentNameInputRef
    ].forEach(ref => ref.current?.clearInput?.());

    setschemeRedeemData({
      entryNo: schred_entryno,
      date: getCurrentDate(),
      schemeId: "",
      schemeName: "",
      accountNameId: "",
      accountName: "",
      agentId: "",
      agent: "",
      accountNoId: "",
      accountNo: "",
      narration: "",
      amount: 0,
      rate: "",
      gm: 0.0,
      printgm: 0,
      isActive: true,
    });

    fetchSchredEntryno();
    fetchSchCurrentRate();
    setCBalance("");
    setRedeemableAmount(0);
    setRedeemableGrams(0);
    setRedeemableSummaryFetched(false);
    setRedeemMode(null);
    setLastEditedField('amount');
    setDataFound(false);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    setTimeout(() => {
      triggerInitialFocus();
    }, 100);
  };

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }

    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deleteredeembyentryno/${schemeRedeemData.entryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}&locationId=${locationId || ''}`
      );
      if (response.status === 200) {
        alert("Entry Deleted !");
        handleClear();
      }
    } catch (error) {
      console.error("Error deleting data:", error.message);
    }
  };

  // ==================== FIND DIALOG FUNCTIONS ====================
  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const handleFind = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/schredeemfindbyentryno/${findEntryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );

      if (response.status === 200 && response.data.length > 0) {
        setFormFieldsFromFoundData(response.data[0]);
        closeFindDialog();
      } else {
        alert("Entry not found");
      }
    } catch (error) {
      console.error("Error finding entry:", error.message);
    }
  };

  const setFormFieldsFromFoundData = (foundData) => {
    const formattedDate = new Date(foundData.Date).toISOString().split("T")[0];

    const schemeObj = schemeNames.find(item => item.value === foundData.SchemeId);
    const accountNameObj = RegcnameData.find(item => item.value === foundData.name);
    const agentObj = agentName.find(item => item.value === foundData.Salesman);

    // Robust resolution of account number and registration auto ID
    const foundAccStr = String(foundData.accno ?? "").trim();
    const foundAccAuto = parseInt(foundData.accno);
    const foundCustId = foundData.name != null ? String(foundData.name).trim() : "";
    const foundSchemeId = foundData.SchemeId != null ? String(foundData.SchemeId).trim() : "";

    const activeList = (schemedatas && schemedatas.length > 0) ? schemedatas : (schemedatasRef.current || []);

    let matchedRegistration = null;
    if (activeList.length > 0) {
      // 1. Filter for registrations belonging to this specific customer
      const custRegistrations = foundCustId
        ? activeList.filter(item => String(item.accname ?? item.Accname ?? item.name ?? "").trim() === foundCustId)
        : [];

      if (custRegistrations.length > 0) {
        // Priority 1: Customer's account matching registration auto ID
        if (!isNaN(foundAccAuto)) {
          matchedRegistration = custRegistrations.find(item =>
            Number(item.auto ?? item.Auto) === foundAccAuto
          );
        }

        // Priority 2: Customer's account matching account number string
        if (!matchedRegistration && foundAccStr) {
          matchedRegistration = custRegistrations.find(item =>
            String(item.accno ?? item.Accno ?? "").trim() === foundAccStr
          );
        }

        // Priority 3: Customer's account matching scheme ID if customer only has 1 account in this scheme
        if (!matchedRegistration && foundSchemeId) {
          const schemeMatches = custRegistrations.filter(item =>
            String(item.schemeId ?? item.SchemeId ?? "").trim() === foundSchemeId
          );
          if (schemeMatches.length === 1) {
            matchedRegistration = schemeMatches[0];
          }
        }

        // Priority 4: If customer has only ONE account overall, that MUST be it
        if (!matchedRegistration && custRegistrations.length === 1) {
          matchedRegistration = custRegistrations[0];
        }
      }

      // If still not matched by customer, search globally across all registrations
      if (!matchedRegistration) {
        // Global Priority 1: Match by auto primary key ID
        if (!isNaN(foundAccAuto)) {
          matchedRegistration = activeList.find(item =>
            Number(item.auto ?? item.Auto) === foundAccAuto
          );
        }
        // Global Priority 2: Match by exact account number string
        if (!matchedRegistration && foundAccStr) {
          matchedRegistration = activeList.find(item =>
            String(item.accno ?? item.Accno ?? "").trim() === foundAccStr
          );
        }
      }
    }

    const resolvedAccountNo = matchedRegistration
      ? String(matchedRegistration.accno ?? matchedRegistration.Accno ?? "").trim()
      : (Accno.find(item => String(item.label).trim() === foundAccStr)?.label || foundAccStr);

    const resolvedAccountNoId = matchedRegistration
      ? (matchedRegistration.auto ?? matchedRegistration.Auto)
      : (Accno.find(item => String(item.label).trim() === foundAccStr)?.auto ?? (!isNaN(foundAccAuto) ? foundAccAuto : ""));

    const savedAmt = parseFloat(foundData.Amount) || 0;
    const excessAmt = parseFloat(foundData.ExcessAmount) || 0;
    const rateVal = parseFloat(foundData.rate) || 0;
    const grmVal = parseFloat(foundData.grm) || 0;
    const calculatedMarketAmt = (rateVal > 0 && grmVal > 0) ? parseFloat((grmVal * rateVal).toFixed(2)) : 0;
    
    // Effective excess is either explicitly stored or inferred from market value difference
    const effectiveExcess = excessAmt > 0
      ? excessAmt
      : (calculatedMarketAmt > savedAmt + 0.01 ? parseFloat((calculatedMarketAmt - savedAmt).toFixed(2)) : 0);

    const totalPayout = effectiveExcess > 0 ? (savedAmt + effectiveExcess) : savedAmt;

    setschemeRedeemData({
      entryNo: foundData.entryno,
      date: formattedDate,
      schemeId: foundData.SchemeId,
      schemeName: schemeObj ? schemeObj.label : "",
      accountNameId: foundData.name,
      accountName: accountNameObj ? accountNameObj.label : "",
      agentId: foundData.Salesman,
      agent: agentObj ? agentObj.label : "",
      accountNoId: resolvedAccountNoId,
      accountNo: resolvedAccountNo,
      amount: totalPayout,
      gm: foundData.grm,
      narration: foundData.NARRATION,
      rate: foundData.rate,
      printgm: foundData.Printgm,
      isActive: foundData.isActive === 1 || foundData.isActive === true,
    });

    // Populate redeemable summary and mode so Gold Appreciation Breakdown panel & edits work accurately
    setRedeemableAmount(savedAmt);
    setRedeemableGrams(grmVal);
    setRedeemableSummaryFetched(true);
    setRedeemMode(effectiveExcess > 0 ? 'custom' : 'total');

    if (foundData.SchemeId) {
      filterAccountNumbersByScheme(foundData.SchemeId);
    }

    if (resolvedAccountNoId && foundData.SchemeId) {
      CurrentBalancebyAccno(resolvedAccountNoId, foundData.SchemeId);
      // Fetch remaining unredeemed balance in account to set true maximum allowable weight & amount for edit
      axios.get(`${apiBaseUrl}/main/redeemableSummary/${resolvedAccountNoId}/${foundData.SchemeId}/${dbCode}`)
        .then((res) => {
          if (res.status === 200 && res.data && res.data.length > 0) {
            const remAmt = parseFloat(res.data[0].redeemableAmount) || 0;
            const remGms = parseFloat(res.data[0].redeemableGrams) || 0;
            const totalMaxGms = grmVal + Math.max(0, remGms);
            const totalMaxAmt = savedAmt + Math.max(0, remAmt);
            setRedeemableAmount(totalMaxAmt);
            setRedeemableGrams(totalMaxGms);
          }
        })
        .catch((err) => {
          console.error("Error fetching remaining summary on edit:", err.message);
        });
    }

    setDataFound(true);
    setEditDisabled(false);
    setDeleteDisabled(false);
    setSaveDisabled(true);
  };

  // ==================== NAVIGATION FUNCTIONS ====================
  const handleFindprev = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRedfindprev/${schemeRedeemData.entryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );

      if (response.status === 200 && response.data.length > 0) {
        setFormFieldsFromFoundData(response.data[0]);
      }
    } catch (error) {
      console.error("Error finding previous entry:", error.message);
    }
  };

  const handleFindnext = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRedfindnext/${schemeRedeemData.entryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );

      if (response.status === 200 && response.data.length > 0) {
        setFormFieldsFromFoundData(response.data[0]);
      }
    } catch (error) {
      console.error("Error finding next entry:", error.message);
    }
  };

  const handleFindfirst = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRedfindfirst/${schemeRedeemData.entryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );

      if (response.status === 200 && response.data.length > 0) {
        setFormFieldsFromFoundData(response.data[0]);
      }
    } catch (error) {
      console.error("Error finding first entry:", error.message);
    }
  };

  const handleFindlast = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRedfindlast/${schemeRedeemData.entryNo}/${parseInt(agentCode)}/${dbCode}/${fyid}?formId=${formId || ''}`
      );

      if (response.status === 200 && response.data.length > 0) {
        setFormFieldsFromFoundData(response.data[0]);
      }
    } catch (error) {
      console.error("Error finding last entry:", error.message);
    }
  };

  const updateNavRefs = (refs) => {
    if (refs.saveButtonRef && refs.saveButtonRef.current) {
      saveButtonRef.current = refs.saveButtonRef.current;
      registerRef("SaveBtn")(refs.saveButtonRef.current);
    }
    if (refs.editButtonRef && refs.editButtonRef.current) {
      editButtonRef.current = refs.editButtonRef.current;
      registerRef("EditBtn")(refs.editButtonRef.current);
    }
  };

  const comboInputCls = "w-full h-[24px] px-2 bg-white text-[11px] border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9] font-Inter";

  return (
    <div
      className="bg-[#f0f2f5] w-[780px] rounded-xl shadow-xl flex flex-col items-center absolute transition-all duration-300 box-border border border-gray-300 font-Inter overflow-hidden"
      style={{ zIndex }}
    >
      <WindowHeader
        title={formName || "Scheme Redeem"}
        logo={headeLogo}
        onClose={onClose}
        className="!h-9 bg-[#0008a9] text-white shrink-0"
        closeBtnClassName="!h-6 !w-6 my-auto mr-1.5 bg-red-600 hover:bg-red-700 rounded-sm"
      />

      <div className="w-full flex-shrink-0">
        <ActionToolbar
          bgColor="#EAF0FC"
          size="small"
          navBgColor="#0f56d3"
          navIconColor="#ffffff"
          showSave={isFieldVisible("SaveBtn")}
          showPrint={isFieldVisible("PrintBtn")}
          showClear={isFieldVisible("ClearBtn")}
          showFind={isFieldVisible("FindBtn")}
          showEdit={isFieldVisible("EditBtn")}
          showDelete={isFieldVisible("DeleteBtn")}
          showExit={isFieldVisible("ExitBtn")}
          showNavigation={
            isFieldVisible("FirstBtn") ||
            isFieldVisible("PrevBtn") ||
            isFieldVisible("NextBtn") ||
            isFieldVisible("LastBtn")
          }
          saveDisabled={saveDisabled || dataFound}
          editDisabled={editDisabled || !dataFound}
          deleteDisabled={deleteDisabled || !dataFound}
          dataFound={dataFound}
          permissions={permissions}
          permissionKey="schemeRedeem"
          onSave={handleSubmit}
          onClear={handleClear}
          onFind={openFindDialog}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onExit={onClose}
          onFirst={handleFindfirst}
          onPrevious={handleFindprev}
          onNext={handleFindnext}
          onLast={handleFindlast}
          showSettingsBar={true}
          settingsOptions={[
            {
              label: "Form Design",
              onClick: () => setShowFormDesignModal(true),
            },
          ]}
          onRefsUpdate={updateNavRefs}
        />
      </div>

      <div className="w-full p-2 flex flex-col gap-1.5 box-border">
        {/* Left and Right Cards Grid */}
        <div className="grid grid-cols-2 gap-2">
          {/* LEFT CARD: Account & Scheme Master Details */}
          <div className="bg-white rounded-lg p-2.5 border border-gray-200 flex flex-col gap-2 shadow-sm justify-between">
            {isFieldVisible("EntryNo") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("EntryNo")}>Entry No</label>
                <input
                  type="text"
                  readOnly
                  ref={(el) => {
                    registerRef("EntryNo")(el);
                    entryNoInputRef.current = el;
                  }}
                  value={schemeRedeemData.entryNo}
                  onKeyDown={(e) => handleKeyDown(e, "EntryNo")}
                  className="w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] bg-slate-50 text-center font-bold text-[#0008a9] font-Inter"
                  style={getInputStyle("EntryNo")}
                />
              </div>
            )}

            {isFieldVisible("SchemeName") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("SchemeName")}>Scheme Name</label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("SchemeName")(el);
                    schemeIdInputRef.current = el;
                  }}
                  options={schemeNames}
                  disabled={isFieldDisabled("SchemeName")}
                  value={schemeRedeemData.schemeId}
                  onSelect={(opt) => {
                    if (!opt || !opt.value) {
                      setschemeRedeemData(prev => ({
                        ...prev,
                        schemeId: "",
                        schemeName: "",
                        accountNoId: "",
                        accountNo: "",
                        accountNameId: "",
                        accountName: "",
                      }));
                      filterAccountNumbersByScheme(null);
                      setCBalance("");
                      setRedeemableAmount(0);
                      setRedeemableGrams(0);
                      setRedeemableSummaryFetched(false);
                      setRedeemMode(null);
                      return;
                    }
                    setschemeRedeemData(prev => ({
                      ...prev,
                      schemeId: opt.value,
                      schemeName: opt.label || ""
                    }));
                    filterAccountNumbersByScheme(opt.value);
                  }}
                  onClear={() => {
                    setschemeRedeemData(prev => ({
                      ...prev,
                      schemeId: "",
                      schemeName: "",
                      accountNoId: "",
                      accountNo: "",
                      accountNameId: "",
                      accountName: "",
                    }));
                    filterAccountNumbersByScheme(null);
                    setCBalance("");
                    setRedeemableAmount(0);
                    setRedeemableGrams(0);
                    setRedeemableSummaryFetched(false);
                    setRedeemMode(null);
                  }}
                  onInputChange={(txt) => {
                    if (!txt) {
                      setschemeRedeemData(prev => ({
                        ...prev,
                        schemeId: "",
                        schemeName: "",
                        accountNoId: "",
                        accountNo: "",
                        accountNameId: "",
                        accountName: "",
                      }));
                      filterAccountNumbersByScheme(null);
                      setCBalance("");
                      setRedeemableAmount(0);
                      setRedeemableGrams(0);
                      setRedeemableSummaryFetched(false);
                      setRedeemMode(null);
                    }
                  }}
                  onFreeInput={(txt) => {
                    setschemeRedeemData(prev => ({
                      ...prev,
                      schemeId: "",
                      schemeName: txt || "",
                      ...(txt ? {} : { accountNoId: "", accountNo: "", accountNameId: "", accountName: "" })
                    }));
                    filterAccountNumbersByScheme(null);
                    if (!txt) {
                      setCBalance("");
                      setRedeemableAmount(0);
                      setRedeemableGrams(0);
                      setRedeemableSummaryFetched(false);
                      setRedeemMode(null);
                    }
                  }}
                  onKeyDown={(e) => handleKeyDown(e, "SchemeName")}
                  placeholder="Select scheme..."
                  showArrow={true}
                  clearable={true}
                  className="w-full h-[24px]"
                  inputClassName={comboInputCls}
                  inputStyle={getInputStyle("SchemeName")}
                />
              </div>
            )}

            {isFieldVisible("AccountNumber") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("AccountNumber")}>Account Number</label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("AccountNumber")(el);
                    accountnumberInputRef.current = el;
                  }}
                  options={filteredaccNo}
                  disabled={isFieldDisabled("AccountNumber")}
                  value={schemeRedeemData.accountNo || ""}
                  onSelect={(opt) => handlefindAccountNo(opt || { value: "", label: "" })}
                  onInputChange={(text) => {
                    setschemeRedeemData(prev => ({ ...prev, accountNo: text }));
                  }}
                  onFreeInput={(text) => {
                    const match = filteredaccNo.find(o => o.label && o.label.toString().trim().toLowerCase() === text.trim().toLowerCase());
                    if (match) {
                      handlefindAccountNo(match);
                    } else {
                      setschemeRedeemData(prev => ({ ...prev, accountNo: text }));
                    }
                  }}
                  onClear={() => {
                    setschemeRedeemData(prev => ({
                      ...prev,
                      accountNoId: "",
                      accountNo: "",
                    }));
                    setCBalance("");
                    setRedeemableAmount(0);
                    setRedeemableGrams(0);
                    setRedeemableSummaryFetched(false);
                    setRedeemMode(null);
                  }}
                  onKeyDown={(e) => handleKeyDown(e, "AccountNumber")}
                  placeholder="Search account no..."
                  showArrow={true}
                  clearable={true}
                  className="w-full h-[24px]"
                  inputClassName={comboInputCls}
                  inputStyle={getInputStyle("AccountNumber")}
                />
              </div>
            )}

            {isFieldVisible("CustomerName") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("CustomerName")}>Customer Name</label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("CustomerName")(el);
                    accountNameInputRef.current = el;
                  }}
                  options={RegcnameData}
                  disabled={isFieldDisabled("CustomerName")}
                  value={schemeRedeemData.accountNameId}
                  onSelect={handleAccountNameSelection}
                  onClear={() => {
                    setschemeRedeemData(prev => ({
                      ...prev,
                      accountNameId: "",
                      accountName: "",
                    }));
                  }}
                  onFreeInput={(txt) => setschemeRedeemData(prev => ({ ...prev, accountNameId: "", accountName: txt }))}
                  onKeyDown={(e) => handleKeyDown(e, "CustomerName")}
                  placeholder="Search customer..."
                  showArrow={true}
                  clearable={true}
                  className="w-full h-[24px]"
                  inputClassName={comboInputCls}
                  inputStyle={getInputStyle("CustomerName")}
                />
              </div>
            )}
            {isFieldVisible("Active") && (
              <div
                className={`flex items-center justify-between pt-1.5 border-t border-gray-100 ${
                  !schemeRedeemData.accountNoId ? "invisible" : ""
                }`}
                style={{
                  visibility: schemeRedeemData.accountNoId ? "visible" : "hidden",
                }}
              >
                <span className="text-[10px] font-bold text-gray-500 font-Inter" style={getLabelStyle("Active")}>Account Status:</span>
                <button
                  type="button"
                  ref={(el) => {
                    registerRef("Active")(el);
                  }}
                  onClick={toggleAccountStatus}
                  disabled={isFieldDisabled("Active") || (saveDisabled && editDisabled)}
                  className={`px-3 py-0.5 text-[10px] font-bold rounded-full border-none cursor-pointer text-white transition-colors duration-200 font-Inter ${
                    schemeRedeemData.isActive ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
                  } ${(saveDisabled && editDisabled) ? "opacity-60 cursor-not-allowed" : ""}`}
                  style={getInputStyle("Active")}
                >
                  {schemeRedeemData.isActive ? "Active" : "Closed"}
                </button>
              </div>
            )}
          </div>

          {/* RIGHT CARD: Customer & Transaction Details */}
          <div className="bg-white rounded-lg p-2.5 border border-gray-200 flex flex-col gap-2 shadow-sm justify-between">
            {isFieldVisible("Date") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("Date")}>Date</label>
                <input
                  type="date"
                  ref={(el) => {
                    registerRef("Date")(el);
                    dateInputRef.current = el;
                  }}
                  disabled={isFieldDisabled("Date")}
                  min={minDate}
                  max={maxDate}
                  value={schemeRedeemData.date}
                  onKeyDown={(e) => handleKeyDown(e, "Date")}
                  onChange={(e) => {
                    setschemeRedeemData({ ...schemeRedeemData, date: e.target.value });
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val && !isDateInFy(val)) {
                      alert("Date incompatible with financial year");
                    }
                  }}
                  className="w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9] font-Inter"
                  style={getInputStyle("Date")}
                />
              </div>
            )}

            {isFieldVisible("Agent") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("Agent")}>Agent</label>
                <SherComboBox
                  comboRef={(el) => {
                    registerRef("Agent")(el);
                    agentNameInputRef.current = el;
                  }}
                  options={agentName}
                  readOnly={true}
                  disabled={isFieldDisabled("Agent")}
                  value={schemeRedeemData.agentId}
                  onSelect={(opt) => setschemeRedeemData(prev => ({ ...prev, agentId: opt?.value || "", agent: opt?.label || "" }))}
                  onFreeInput={(txt) => setschemeRedeemData(prev => ({ ...prev, agentId: "", agent: txt }))}
                  onKeyDown={(e) => handleKeyDown(e, "Agent")}
                  placeholder="Select agent..."
                  showArrow={false}
                  clearable={false}
                  className="w-full h-[24px]"
                  inputClassName={comboInputCls}
                  inputStyle={getInputStyle("Agent")}
                />
              </div>
            )}

            {isFieldVisible("Amount") && (
              <div className="flex flex-col">
                <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("Amount")}>Amount (₹)</label>
                <input
                  type="number"
                  ref={(el) => {
                    registerRef("Amount")(el);
                    amountInputRef.current = el;
                  }}
                  disabled={isFieldDisabled("Amount")}
                  readOnly={redeemMode === 'total'}
                  value={schemeRedeemData.amount !== undefined ? schemeRedeemData.amount : ""}
                  onKeyDown={(e) => handleKeyDown(e, "Amount")}
                  onChange={handleAmountChange}
                  onBlur={handleAmountBlur}
                  placeholder="0.00"
                  className={`w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] outline-none text-right font-bold text-gray-800 focus:border-[#0008a9] font-Inter ${redeemMode === 'total' ? 'bg-slate-50' : ''}`}
                  style={getInputStyle("Amount")}
                />
              </div>
            )}

            <div className="grid grid-cols-2 gap-2">
              {isFieldVisible("GoldRate") && (
                <div className="flex flex-col">
                  <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("GoldRate")}>Gold Rate (₹/gm)</label>
                  <input
                    type="number"
                    ref={(el) => {
                      registerRef("GoldRate")(el);
                      rateInputRef.current = el;
                    }}
                    disabled={isFieldDisabled("GoldRate")}
                    readOnly={redeemMode === 'total'}
                    value={schemeRedeemData.rate !== undefined ? schemeRedeemData.rate : ""}
                    onKeyDown={(e) => handleKeyDown(e, "GoldRate")}
                    onChange={handleRateChange}
                    placeholder="0.00"
                    className={`w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] outline-none text-right focus:border-[#0008a9] font-Inter ${redeemMode === 'total' ? 'bg-slate-50' : ''}`}
                    style={getInputStyle("GoldRate")}
                  />
                </div>
              )}
              {isFieldVisible("RedeemedGrams") && (
                <div className="flex flex-col">
                  <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("RedeemedGrams")}>Redeemed Grams (GM)</label>
                  <input
                    type="number"
                    step="any"
                    readOnly={redeemMode === 'total'}
                    ref={(el) => {
                      registerRef("RedeemedGrams")(el);
                      gmInputRef.current = el;
                    }}
                    value={schemeRedeemData.gm !== undefined ? schemeRedeemData.gm : ""}
                    onKeyDown={(e) => handleKeyDown(e, "RedeemedGrams")}
                    onChange={handleGmChange}
                    onBlur={handleGmBlur}
                    placeholder="0.000"
                    className={`w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] text-right font-bold text-green-700 font-Inter ${redeemMode === 'total' ? 'bg-slate-50' : 'bg-white outline-none focus:border-[#0008a9]'}`}
                    style={getInputStyle("RedeemedGrams")}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col gap-1.5 pt-1.5 border-t border-gray-100">
              {isFieldVisible("PrintGrams") && (
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="printGm"
                    ref={(el) => {
                      registerRef("PrintGrams")(el);
                    }}
                    disabled={isFieldDisabled("PrintGrams")}
                    checked={schemeRedeemData.printgm === 1}
                    onChange={(e) =>
                      setschemeRedeemData({ ...schemeRedeemData, printgm: e.target.checked ? 1 : 0 })
                    }
                    className="w-4 h-4 accent-[#0008a9] cursor-pointer"
                    style={getInputStyle("PrintGrams")}
                  />
                  <label htmlFor="printGm" className="text-[10px] font-bold text-gray-500 cursor-pointer select-none font-Inter" style={getLabelStyle("PrintGrams")}>
                    Print Grams (GM) on receipt
                  </label>
                </div>
              )}

            </div>
          </div>
        </div>

        {/* REDESIGNED COMPACT REDEEM & BALANCE BAR */}
        <div className="bg-white rounded-lg p-2.5 border border-gray-200 flex flex-col gap-2 shadow-sm font-Inter">
          {/* Redeemable Quick-Action Banner (new entries only) */}
          {!dataFound && (redeemableAmount > 0 || redeemableGrams > 0) && (
            <div className="flex items-center justify-between gap-2 px-2.5 py-1.5 bg-gradient-to-r from-blue-50/80 via-slate-50 to-amber-50/70 border border-blue-200/70 rounded-md">
              <div className="flex items-center gap-4 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-blue-600"></span>
                  <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">Saved Amt:</span>
                  <span className="text-[12px] font-bold text-[#0008a9]">₹ {redeemableAmount.toFixed(2)}</span>
                </div>
                <div className="h-3 w-px bg-gray-300/80"></div>
                <div className="flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-600"></span>
                  <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">Weight:</span>
                  <span className="text-[12px] font-bold text-emerald-700">{redeemableGrams.toFixed(3)} gm</span>
                </div>
              </div>
              {/* Quick Action Pill Buttons */}
              <div className="flex items-center gap-1.5 shrink-0">
                <button
                  type="button"
                  onClick={handleRedeemAll}
                  title="Redeem all saved amount & weight"
                  className={`px-2.5 py-1 text-[10px] font-semibold rounded-full cursor-pointer transition-all duration-150 flex items-center gap-1 border ${
                    redeemMode === 'total'
                      ? 'bg-[#0008a9] text-white border-[#0008a9] shadow-sm'
                      : 'bg-white text-[#0008a9] border-blue-300 hover:bg-blue-600 hover:text-white hover:border-blue-600'
                  }`}
                >
                  <span className="text-[9px]">⚡</span> Redeem All
                </button>
                <button
                  type="button"
                  onClick={handleCustomRedeem}
                  title="Enter custom redeem amount & weight"
                  className={`px-2.5 py-1 text-[10px] font-semibold rounded-full cursor-pointer transition-all duration-150 flex items-center gap-1 border ${
                    redeemMode === 'custom'
                      ? 'bg-amber-500 text-white border-amber-500 shadow-sm'
                      : 'bg-white text-amber-700 border-amber-300 hover:bg-amber-500 hover:text-white hover:border-amber-500'
                  }`}
                >
                  <span className="text-[9px]">✏️</span> Custom
                </button>
              </div>
            </div>
          )}

          {/* ── GOLD APPRECIATION BREAKDOWN PANEL (shows for both new entries and found entries) ── */}
          {(() => {
            const enteredAmt = parseFloat(schemeRedeemData.amount) || 0;
            const availableSavings = Math.max(0, redeemableAmount);
            const liveExcess = enteredAmt > availableSavings
              ? Math.max(0, parseFloat((enteredAmt - availableSavings).toFixed(2)))
              : 0;

            const shouldShow = (liveExcess > 0) || (!dataFound && redeemMode === 'custom' && enteredAmt > 0);
            if (!shouldShow) return null;

            return (
              <div className={`rounded-md border px-3 py-2 flex flex-col gap-1.5 ${
                liveExcess > 0
                  ? 'bg-gradient-to-r from-orange-50 to-amber-50 border-orange-300'
                  : 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-300'
              }`}>
                {/* Header */}
                <div className="flex items-center justify-between">
                  <span className={`text-[10px] font-bold uppercase tracking-wider ${
                    liveExcess > 0 ? 'text-orange-700' : 'text-green-700'
                  }`}>
                    {liveExcess > 0 ? '🏅 Gold Appreciation Breakdown' : '✅ Custom Redeem'}
                  </span>
                  {liveExcess > 0 && (
                    <span className="text-[9px] font-bold bg-orange-200 text-orange-900 px-2 py-0.5 rounded-full border border-orange-400">
                      Appreciation Applied
                    </span>
                  )}
                </div>

                {/* Breakdown rows */}
                <div className="flex flex-col gap-0.5">
                  {/* Row 1: Saved amount */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                      <span className="text-[10px] text-gray-600 font-medium">
                        Customer Scheme A/c (Dr.)
                      </span>
                    </div>
                    <span className="text-[11px] font-bold text-[#0008a9]">
                      ₹ {availableSavings.toFixed(2)}
                    </span>
                  </div>

                  {/* Row 2: Gold Appreciation (only if excess) */}
                  {liveExcess > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-1.5">
                        <span className="w-2 h-2 rounded-full bg-orange-500"></span>
                        <span className="text-[10px] text-gray-600 font-medium">
                          Gold Appreciation Expense (Dr.)
                        </span>
                      </div>
                      <span className="text-[11px] font-bold text-orange-700">
                        ₹ {liveExcess.toFixed(2)}
                      </span>
                    </div>
                  )}

                  {/* Divider */}
                  <div className="border-t border-dashed border-gray-300 my-0.5"></div>

                  {/* Row 3: Total Cash paid */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-green-600"></span>
                      <span className="text-[10px] text-gray-600 font-semibold">
                        Cash to Customer (Cr.)
                      </span>
                    </div>
                    <span className="text-[12px] font-black text-green-700">
                      ₹ {enteredAmt.toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* Info note */}
                {liveExcess > 0 && (
                  <div className="text-[9px] text-orange-600 font-medium mt-0.5 leading-tight">
                    {availableSavings <= 0
                      ? `⚠️ Customer scheme money balance is ₹ 0.00. Entire ₹ ${liveExcess.toFixed(2)} for ${schemeRedeemData.gm || 0} gm is booked to Gold Appreciation Expense.`
                      : `⚠️ Gold price rose since deposit. Shop absorbs ₹ ${liveExcess.toFixed(2)} as Gold Appreciation Expense.`
                    }
                  </div>
                )}
              </div>
            );
          })()}

          {/* When an account is selected but has NO redeemable amount or weight */}
          {!dataFound && redeemableSummaryFetched && schemeRedeemData.accountNoId && schemeRedeemData.schemeId && redeemableAmount <= 0 && redeemableGrams <= 0 && (
            <div className="flex items-center justify-between gap-2 px-2.5 py-1.5 bg-amber-50/70 border border-amber-200/80 rounded-md">
              <div className="flex items-center gap-2">
                <span className="text-amber-500 text-xs">ℹ️</span>
                <span className="text-[11px] font-semibold text-amber-900">
                  No redeemable amount or weight saved for this scheme account (₹ 0.00 / 0.000 gm).
                </span>
              </div>
              <span className="text-[9px] font-bold uppercase tracking-wider text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full border border-amber-300">
                0 Balance
              </span>
            </div>
          )}

          {/* Narration Field */}
          {isFieldVisible("Narration") && (
            <div className="flex flex-col">
              <label className="text-[10px] font-bold text-gray-500 mb-0.5 font-Inter" style={getLabelStyle("Narration")}>Narration</label>
              <input
                type="text"
                ref={(el) => {
                  registerRef("Narration")(el);
                  narrationInputRef.current = el;
                }}
                disabled={isFieldDisabled("Narration")}
                value={schemeRedeemData.narration}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (!dataFound && saveButtonRef.current) saveButtonRef.current.focus();
                    else if (dataFound && editButtonRef.current) editButtonRef.current.focus();
                  }
                }}
                onChange={(e) =>
                  setschemeRedeemData({ ...schemeRedeemData, narration: e.target.value })
                }
                placeholder="Enter remarks..."
                className="w-full h-[24px] px-3 text-[11px] border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9] font-Inter"
              />
            </div>
          )}

          {/* Slim Balance Strip */}
          <div className="bg-red-50/70 border border-red-200/80 rounded-md px-3 py-1 flex justify-between items-center font-Inter">
            <span className="text-[10px] font-bold text-red-800 tracking-wide uppercase">Current Account Balance:</span>
            <span className="text-[12px] font-black text-red-600">₹ {cBalace || "0.00"}</span>
          </div>
        </div>
      </div>

      {/* Scheme Selection Popup */}
      {showSchemePopup && (
        <div className="fixed inset-0 flex items-center justify-center z-[10005] bg-black bg-opacity-50 font-Inter">
          <div className="bg-white rounded-lg shadow-xl w-[450px] max-h-[400px] overflow-hidden flex flex-col border border-gray-200">
            <div className="bg-[#0008a9] text-white px-4 py-3 flex justify-between items-center">
              <h3 className="text-sm font-bold m-0">
                Select Scheme for {selectedAccountNameValue}
              </h3>
              <button
                onClick={handleClosePopup}
                className="bg-red-600 border-none rounded text-white w-6 h-6 flex items-center justify-center cursor-pointer hover:bg-red-700 transition-colors"
              >
                ✕
              </button>
            </div>
            <div className="p-4 flex-1 overflow-y-auto flex flex-col gap-3">
              <p className="text-xs text-gray-600 m-0">
                This customer has multiple accounts under different schemes. Please select a scheme:
              </p>
              <div className="flex flex-col gap-2">
                {availableSchemes.map((scheme, index) => (
                  <button
                    key={index}
                    onClick={() => handleSchemeSelection(scheme)}
                    className="w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-500 transition-all duration-200 cursor-pointer bg-white"
                  >
                    <div className="font-bold text-sm text-[#0008a9]">
                      {scheme.schemeName}
                    </div>
                    {scheme.accountData.map((acc, idx) => (
                      <div key={idx} className="text-xs text-gray-500 mt-1 font-medium">
                        Account No: {acc.accno}
                      </div>
                    ))}
                  </button>
                ))}
              </div>
            </div>
            <div className="p-3 bg-gray-50 border-t border-gray-200 flex justify-end">
              <button
                onClick={handleClosePopup}
                className="px-4 py-2 text-xs font-bold bg-gray-500 hover:bg-gray-600 text-white rounded border-none cursor-pointer transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Find Dialog */}
      {showFindDialog && (
        <div className="fixed inset-0 flex items-center justify-center z-[10005] bg-black bg-opacity-50 font-Inter">
          <div className="bg-white rounded-lg shadow-xl w-[320px] p-4 flex flex-col gap-3 border border-gray-200 relative">
            <h3 className="text-sm font-bold text-gray-800 m-0">Find Scheme Redeem</h3>
            <div className="flex gap-2 w-full mt-1">
              <input
                type="text"
                value={findEntryNo}
                onChange={(e) => setFindEntryNo(e.target.value)}
                placeholder="Enter Entry No"
                className="flex-1 h-8 px-3 text-xs border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9]"
                onKeyDown={(e) => e.key === 'Enter' && handleFind()}
              />
              <button
                onClick={handleFind}
                className="h-8 px-4 bg-[#0008a9] hover:bg-[#0006c8] text-white font-bold text-xs rounded-[5px] border-none cursor-pointer transition-colors"
              >
                Find
              </button>
            </div>
            <button
              onClick={closeFindDialog}
              className="absolute top-2 right-2 border-none bg-transparent text-gray-400 hover:text-gray-600 cursor-pointer text-sm"
            >
              ✕
            </button>
          </div>
        </div>
      )}
      {/* Form Design Modal */}
      {showFormDesignModal && (
        <div className="fixed inset-0" style={{ zIndex: zIndex ? zIndex + 50 : 10050 }}>
          <FormDesign
            onClose={() => setShowFormDesignModal(false)}
            formName={voucherType || "SCHEME REDEEM"}
            initialFields={defaultSchemeRedeemFormFields}
            zIndex={zIndex ? zIndex + 50 : 10050}
            highlightFieldId={activeFieldId}
            onSave={(updatedFields) => {
              setFormFields(updatedFields);
            }}
          />
        </div>
      )}
    </div>
  );
}

export default SchemeRedeem;
